export default __webpack_public_path__ + "static/media/kwh.5b8cb29f.svg";